module.exports = __webpack_public_path__ + "img/8.a75e973d.jpeg";